module.exports = __webpack_public_path__ + "static/media/icRemittanceMTD.0e3cf7d4.svg";